import { useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

const defaultClasses = {
  happenings: 'products_state happenings_state',
  hotel_directory: 'products_state hotel_directory_state screen_builder_state',
  guest_request_menu:
    'products_state guest_request_state menu_state preview_state',
  settings: 'products_state in_room_dining_state settings_state',
  ird_orders: 'products_state in_room_dining_state orders_state',
  menu_builder: 'products_state in_room_dining_state menu_state',
};

const getCustomClass = (pathname) => {
  if (pathname.includes('guest_request/menu')) {
    return defaultClasses.guest_request_menu;
  }
  if (pathname.includes('hotel_directory')) {
    return defaultClasses.hotel_directory;
  }
  if (pathname.includes('happenings')) {
    return defaultClasses.happenings;
  }
  if (pathname.includes('settings')) {
    return defaultClasses.settings;
  }
  if (pathname.includes('in_room_dining') && pathname.includes('orders')) {
    return defaultClasses.ird_orders;
  }
  if (pathname.includes('in_room_dining') && pathname.includes('menu')) {
    return defaultClasses.menu_builder;
  }
  if (pathname.includes('in_room_dining') && pathname.includes('settings')) {
    return defaultClasses.settings;
  }
  return '';
};

/**
 * Handling Custom Class for the App Container
 */
const useWbAppLayout = () => {
  const wrapperClassStore = useSelector(
    (state) => state.application.wrapperClass,
  );
  const [wrapperClass, setWrapperClass] = useState('');
  const location = useLocation();

  useLayoutEffect(() => {
    let customClass = '';

    customClass = getCustomClass(location.pathname);
    setWrapperClass(`${customClass} ${wrapperClassStore}`);
  }, [location, wrapperClassStore]);

  return {
    wrapperClass,
  };
};

export default useWbAppLayout;
